import { useEffect } from 'react';
import { toast } from 'react-toastify';

// Surface an RTK Query error as a toast. Without this, a failed Graph call just
// leaves `data` undefined, so memberships / provenance silently vanish with no
// signal to the user. Fires once per error transition (toastId dedups repeats).
export function useQueryErrorToast(isError: boolean, message: string) {
  useEffect(() => {
    if (isError) toast.error(message, { toastId: message });
  }, [isError, message]);
}
